import { render, staticRenderFns } from "./u-dialog-color-bg-rounded.vue?vue&type=template&id=462720ee&scoped=true"
import script from "./u-dialog-color-bg-rounded.vue?vue&type=script&lang=js"
export * from "./u-dialog-color-bg-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462720ee",
  null
  
)

export default component.exports